module.exports = __webpack_public_path__ + "img/11087939_L.48eb52bb.png";